<div>
  <!-- A network can't cover the service fee: it sits on one voucher per order, so it
       would land on whichever member redeems that voucher. -->
  @if (!company) {
    <!-- nothing until the company is loaded, so a network never sees the switch -->
  } @else if (company.is_group_admin) {
    <section hlmCard>
      <div hlmCardHeader>
        <h2 hlmCardTitle>Gebühren im Netzwerk</h2>
        <p hlmCardDescription>
          Du trägst die Gebühren. Deine Mitglieder erhalten den vollen Einlösewert dessen, was sie
          einlösen.
        </p>
      </div>
      <div hlmCardContent class="space-y-3">
        <div hlmItem variant="outline" class="flex-col items-stretch gap-3">
          <span hlmItemTitle>Gebühren im Überblick</span>
          <dl class="divide-y text-sm">
            @for (fee of fees; track fee.name) {
              <div class="grid gap-1 py-2 sm:grid-cols-[10rem_1fr] sm:gap-4">
                <dt class="font-medium">{{ fee.name }}</dt>
                <dd hlmMuted>{{ fee.detail }}</dd>
              </div>
            }
          </dl>
        </div>
      </div>
    </section>
  } @else {
    <form [formGroup]="feesForm">
      <section hlmCard>
        <div hlmCardHeader>
          <h2 hlmCardTitle>Servicegebühr</h2>
          <p hlmCardDescription>
            Lege fest, wer die Servicegebühr von {{ serviceFee() }} pro Bestellung trägt.
          </p>
        </div>

        <div hlmCardContent>
          <div hlmItem variant="outline" class="items-start">
            <div hlmItemContent>
              <span hlmItemTitle>Servicegebühr für Kunden übernehmen</span>
              <span hlmItemDescription>
                Wenn aktiviert, übernimmt dein Unternehmen die Servicegebühr von {{ serviceFee() }}.
                Die Gebühr wird dir monatlich berechnet, Kunden zahlen dann nur den Gutscheinwert.
              </span>
            </div>
            <div hlmItemActions>
              <hlm-switch
                inputId="company_covers_customer_fee"
                aria-label="Servicegebühr für Kunden übernehmen"
                formControlName="company_covers_customer_fee" />
            </div>
          </div>
          <p hlmMuted class="mt-2 text-xs">Änderungen wirken sich nur auf neue Gutscheine aus.</p>
        </div>

        <div hlmCardFooter class="justify-end border-t pt-4">
          <app-save-button
            #saveButton
            size="sm"
            [disabled]="!formChanged"
            [loading]="loading"
            (clickEvent)="onSubmit()" />
        </div>
      </section>
    </form>
  }
</div>
